import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from 'app/services/user.service';
import { DateTime } from 'luxon';
import * as moment from 'moment-timezone';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IContact } from 'shared/interfaces/contact.interface';
import { IContent } from 'shared/interfaces/content.interface';

@Injectable()
export class ContactService {
	constructor(
		private httpClient: HttpClient,
		private userService: UserService
	) {}

	public getData(contactId: string): Observable<IContact> {
		return this.httpClient.get<IContact>(`contacts/${contactId}`).pipe(
			map((response) => {
				response.birthdate = response.birthdate
					? DateTime.fromFormat(response.birthdate, 'yyyy-MM-dd').toFormat(
							'dd-MM-yyyy'
					  )
					: null;

				return {
					refUserId: response.refUserId,
					birthdate: response.birthdate,
					city: response.city,
					displayName: response.displayName,
					fiscalId: response.fiscalId,
					gender: response.gender,
					id: response.id,
					state: response.state,
				};
			})
		);
	}

	public getContent(contactId: string, period?: string): Observable<IContent> {
		const periodMap = {
			week: 7,
			twoWeeks: 15,
			month: 30,
		};

		const today = DateTime.now().toFormat('yyyy-MM-dd');
		const initialDate = DateTime.now()
			.minus({ days: periodMap[period] || 30 })
			.toFormat('yyyy-MM-dd');
		const timezone =
			moment.tz.guess() || this.userService.getUserLocal().timezone;

		return this.httpClient.get<IContent>(
			`professionals/content/contact/${contactId}?startDate=${initialDate}&endDate=${today}&timezone=${timezone}`
		);
	}

	public updateData(contactData: IContact): Observable<IContact> {
		const newData = Object.assign({}, contactData);

		Object.keys(newData).forEach((key) => {
			newData[key] = newData[key] ? newData[key] : null;
		});

		if (newData.birthdate) {
			newData.birthdate = DateTime.fromFormat(
				contactData.birthdate.replace(/(\/)/g, '-'),
				'dd-MM-yyyy'
			).toFormat('yyyy-MM-dd');
		}

		return this.httpClient.patch<IContact>(
			`contacts/${newData.id}`,
			JSON.stringify(newData)
		);
	}

	public getMoodTrackerOfPatient(contactId: string, startDate, endDate) {
		const timezone =
			moment.tz.guess() || this.userService.getUserLocal().timezone;

		return this.httpClient.get<any>(
			`professionals/mood-tracker/patient/${contactId}?startDate=${startDate}&endDate=${endDate}&timezone=${timezone}`
		);
	}
}
